export const mutations = {
  SET_SHOPID (state, payload) {
    state.shopId = payload
  },
  SET_SHOPINFO (state, payload) {
    state.shopInfo = payload
  },
  SET_LEVEL (state, payload) {
    state.level = payload
  },
  SET_THEME (state, payload) {
    state.theme = payload
  },
  SET_BLOG (state, payload) {
    state.blog = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/shop/mutations.js